import { render, staticRenderFns } from "./peopleInfo.vue?vue&type=template&id=d9604de4&scoped=true&"
import script from "./peopleInfo.vue?vue&type=script&lang=js&"
export * from "./peopleInfo.vue?vue&type=script&lang=js&"
import style0 from "./peopleInfo.vue?vue&type=style&index=0&id=d9604de4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9604de4",
  null
  
)

export default component.exports